import React, { useState, useCallback, useRef } from "react";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import cx from "classnames";
import "./Slider.scss";
import { InputErrorList } from "../input/InputErrorList";
export function Slider({ min = 0, max = 100, value, step = 1, defaultValue, label, onChange, validators = [], forceValidation = false, "data-test-id": dataTestId, risk, }) {
    const containerRef = useRef(null);
    const sliderName = useRef("slider_" + Math.random().toString(36).substr(2, 9));
    const [internalValue, setinternalValue] = useState(value || defaultValue || 0);
    const isControlled = typeof value !== "undefined";
    const usedValue = isControlled ? value : internalValue;
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(usedValue, validators, forceValidation);
    useForm(sliderName.current, validity, value, resetValidation, containerRef, errorMessages, label);
    const position = calculatePosition(min, max, usedValue);
    const defaultValueString = (defaultValue || "").toString();
    const onRealChange = useCallback((event) => {
        const value = parseFloat(event.target.value);
        setinternalValue(value);
        onChange && onChange(value);
    }, [onChange]);
    const classes = cx("lysa-ui-slider", validityClasses);
    return (React.createElement("div", { ref: containerRef, className: classes, "data-test-id": dataTestId },
        React.createElement("label", { htmlFor: sliderName.current }, label),
        React.createElement("div", { className: cx("slider", { risk }) },
            React.createElement("div", { className: "slider-bar" }),
            React.createElement("div", { className: "slider-bar slider-bar-active", style: { right: `${position}%` } }),
            React.createElement("input", { type: "range", name: sliderName.current, id: sliderName.current, min: min, max: max, step: step, value: value, defaultValue: isControlled ? undefined : defaultValueString, onChange: onRealChange }),
            React.createElement("div", { className: "slider-handle", style: { right: `${position}%` } })),
        React.createElement(InputErrorList, { errorMessages: errorMessages })));
}
function clamp(min, max, value) {
    return Math.min(Math.max(value, min), max);
}
function calculatePosition(min, max, value) {
    if (typeof value === "undefined") {
        return;
    }
    const val = (clamp(min, max, value) - min) / (max - min);
    return 100 - val * 100;
}
